import b64toBlob from 'b64-to-blob';

export function openFile(data: string, type: Blob['type'] = 'application/pdf') {
  try {
    const blob = b64toBlob(data, type);
    const url = window.URL.createObjectURL(blob);
    window.open(url, '_blank');

    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 100);
  } catch (error) {
    console.error('Error opening file:', error);
    throw error;
  }
}
